export default function ShoppingListItem({ item, prices, priceMode, onToggleCheck, onRemove }) {
  const stores = ['Coles', 'Woolworths', 'Aldi'];

  // Find lowest price across stores
  const storePrices = stores.map(s => prices?.[s]?.price ?? null);
  const validPrices = storePrices.filter(p => p !== null);
  const lowestPrice = validPrices.length ? Math.min(...validPrices) : null;
  const lowestStore = lowestPrice !== null
    ? stores[storePrices.indexOf(lowestPrice)]
    : null;

  const STORE_SHORT = { Coles: 'C', Woolworths: 'W', Aldi: 'A' };
  const STORE_COLOR = { Coles: '#E50016', Woolworths: '#129C4F', Aldi: '#001E5E' };

  function renderPrice() {
    if (!prices) {
      return <span className="sli-price-loading"><span className="skeleton-shimmer" /></span>;
    }

    if (priceMode === 'lowest') {
      if (lowestPrice === null) return <span className="sli-price-na">—</span>;
      return (
        <span className="sli-price-lowest">
          ${lowestPrice.toFixed(2)}
          <span className="sli-store-badge" style={{ background: STORE_COLOR[lowestStore] }}>
            {STORE_SHORT[lowestStore]}
          </span>
        </span>
      );
    }

    if (priceMode === 'all') {
      return (
        <span className="sli-price-all">
          {stores.map(s => {
            const p = prices[s]?.price ?? null;
            const isLowest = p !== null && p === lowestPrice;
            return (
              <span
                key={s}
                className={`sli-price-cell ${isLowest ? 'sli-price-cell--lowest' : ''} ${p === null ? 'sli-price-cell--na' : ''}`}
                style={{ '--store-col': STORE_COLOR[s] }}
              >
                {p !== null ? `$${p.toFixed(2)}` : '—'}
              </span>
            );
          })}
        </span>
      );
    }

    // Single store mode
    const p = prices[priceMode]?.price ?? null;
    if (p === null) return <span className="sli-price-na">—</span>;
    return <span className="sli-price-single">${p.toFixed(2)}</span>;
  }

  const quantityLabel = item.quantity && item.quantity !== 1
    ? ` × ${item.quantity}${item.unit ? ' ' + item.unit : ''}`
    : item.unit ? ` (${item.unit})` : '';

  return (
    <div className={`sli-row ${item.is_checked ? 'sli-row--checked' : ''}`}>
      <button
        className={`sli-checkbox ${item.is_checked ? 'sli-checkbox--checked' : ''}`}
        onClick={() => onToggleCheck(item.id)}
        aria-label={item.is_checked ? 'Uncheck item' : 'Check item for next shop'}
      >
        {item.is_checked && (
          <svg viewBox="0 0 12 10" width="12" height="10" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="1,5 4.5,8.5 11,1" />
          </svg>
        )}
      </button>

      <div className="sli-name-wrap">
        <span className="sli-name">{item.name}</span>
        {quantityLabel && <span className="sli-qty">{quantityLabel}</span>}
      </div>

      <div className="sli-price-wrap">
        {renderPrice()}
      </div>

      <button className="sli-remove" onClick={() => onRemove(item.id)} aria-label="Remove item">✕</button>
    </div>
  );
}
